// extracted by mini-css-extract-plugin
export default {"detailsButtonContainer":"scores-table-container__details-button-container__d0LUD","detailsButton":"scores-table-container__details-button__LpAfD"};